import React from 'react';

const TunnelIcon = ({ svg }) => (
  <div className="tunnel-icon" dangerouslySetInnerHTML={{ __html: svg }} />
);

export default TunnelIcon;